import { Expose } from 'class-transformer';

import { SnModel } from '@lib/common/models';

export class SnMedia extends SnModel {
  @Expose()
  public id: string;

  @Expose()
  public createdTimestamp: string;

  @Expose()
  public updatedTimestamp: string;

  @Expose()
  public file: string;

  @Expose()
  public location: string;

  @Expose()
  public description: string;
}
